import { Box, GridLayout } from '@deity/falcon-ui';
import type { CSSProperties, FC, ReactNode } from 'react';
import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

interface ITRowProps {
  rowHeight?: string;
  rowMaxHeight?: string | 'auto';
  collapsible?: boolean;
  gridTemplateColumns?: string;
  content?: ReactNode;
  isActive?: boolean;
  linkTo?: string;
  style?: CSSProperties;
}

export const TRow: FC<ITRowProps> = ({
  children,
  gridTemplateColumns,
  collapsible = false,
  rowMaxHeight = '500px',
  rowHeight = '80px',
  content,
  isActive,
  linkTo,
  style
}) => {
  const [collapsed, setCollapsed] = useState(true);
  const [height, setHeight] = useState(0);
  const ref = useRef<any>(null);

  useEffect(() => {
    if (ref.current) {
      setHeight(ref.current.clientHeight);
    }
  });

  const backgroundColor = (): string => {
    if (collapsed && !isActive) {
      return 'white';
    }

    return isActive ? '#f2f5f7' : '#dadfe4';
  };

  let boxHeight = '';
  if (collapsed) {
    boxHeight = rowHeight;
  } else if (rowMaxHeight === 'auto') {
    boxHeight = `${height + 88}px`;
  } else {
    boxHeight = rowMaxHeight;
  }

  // eslint-disable-next-line react/no-unstable-nested-components
  const Content = () => (
    <Box
      style={{
        backgroundColor: backgroundColor(),
        position: 'relative',
        overflow: collapsed ? 'hidden' : 'visible',
        // transition: 'all 0.2s ease-in-out',
        height: boxHeight,
        cursor: linkTo ? 'pointer' : 'default'
      }}
    >
      <GridLayout
        pl="xxl"
        pr="xxl"
        gridTemplateColumns={gridTemplateColumns}
        alignContent="center"
        alignItems="center"
        justifyItems="start"
        justifySelf="start"
        style={{
          borderBottom: '1px solid #E0E2E5',
          height: rowHeight,
          cursor: collapsible ? 'pointer' : '',
          zIndex: 100,
          ...style
        }}
        onClick={() => collapsible && setCollapsed(!collapsed)}
      >
        {React.Children.toArray(children)[0]}
      </GridLayout>
      <Box
        ref={ref}
        boxShadow="subtle"
        bg="white"
        borderRadius="small"
        style={{
          position: 'absolute',
          top: rowHeight,
          width: '102%',
          transform: 'translateX(-1%)',
          boxSizing: 'border-box',
          display: collapsed ? 'none' : 'flex'
        }}
      >
        {content}
        <Box
          style={{
            position: 'absolute',
            left: '50%',
            transform: 'translate(-20px,-20px)',
            width: 0,
            height: 0,
            borderLeft: '20px solid transparent',
            borderRight: '20px solid transparent',
            /* z-index: -1; */
            borderBottom: '20px solid white'
          }}
        />
      </Box>
    </Box>
  );

  return linkTo ? (
    <Link to={linkTo as any} style={{ textDecoration: 'none' }}>
      <Content />
    </Link>
  ) : (
    <Content />
  );
};
